import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CreateBroadcastActionPayload, EndBroadcastActionPayload, VHLiveState } from '../../types';

type BroadcastState = {
    vhlive: VHLiveState;
};
const initialState: BroadcastState = {
    vhlive: {
        viewers: 0,
    },
};
const broadcastSlice = createSlice({
    name: 'broadcast',
    initialState,
    reducers: {
        updateVHLiveState(state, action: PayloadAction<Partial<VHLiveState>>) {
            state.vhlive = {
                ...state.vhlive,
                ...action.payload,
            };
        },

        resetVHLiveState(state) {
            state.vhlive = initialState.vhlive;
        },
        resetBroadcastState() {
            return initialState;
        },
    },
});

export const createBroadcastAction = createAction<CreateBroadcastActionPayload>('conference/broadcast/createBroadcast');
export const startBroadcastAction = createAction<void>('conference/broadcast/startBroadcast');
export const stopBroadcastAction = createAction<void>('conference/broadcast/stopBroadcast');
export const shareBroadcastAction = createAction<void>('conference/broadcast/shareBroadcast');
export const endBroadcastAction = createAction<Maybe<EndBroadcastActionPayload>>('conference/broadcast/endBroadcast');
export const { updateVHLiveState, resetVHLiveState, resetBroadcastState } = broadcastSlice.actions;
export const broadcastReducer = broadcastSlice.reducer;
